import { RootState } from '../Store';
import { CountryIsoCodes } from '../../components/common/Constants';

/**
 * Selects the currency symbol based on configured country.
 */
export const selectCurrencySymbol = (state: RootState) => {
  const countryCode = state.appConfig.countryCode;
  switch (countryCode) {
    case CountryIsoCodes.DE:
    case CountryIsoCodes.AT:
    case CountryIsoCodes.ES:
      return '€';
    case CountryIsoCodes.GB:
      return '£';
    default:
      return '£';
  }
};
